'use strict';

angular.module('atex.dam').factory('DamStoryContentService', ['$rootScope', '$q', 'ContentService', 'DamService' ,'DamNotificationService', '$translate',
  function ($rootScope, $q, ContentService, DamService, DamNotificationService, $translate) {
    var contents;

    $rootScope.$on('dam:logout', function () {
      contents = undefined;
    });

    var getTemplateKey = function (key) {
      return key.split("template:")[1];
    };

    var setByPath = function (json, path, value) {
      var steps = path.split("/");

      var content = json;
      angular.forEach(steps, function (step, key) {
        if (!content[step]) {
          content[step] = {};
        }

        if (key === (steps.length - 1)) {
          content[step] = JSON.parse(value);
        }
        content = content[step];
      });
    };

    var removeType = function (configurations) {
      angular.forEach(configurations, function (configuration, key) {
        if (key.endsWith("_type")) {
          delete configurations[key];
        }
      });
    };

    var getStoryContentConfigurations = function () {
      var deferred = $q.defer();

      if (contents) {
        deferred.resolve(contents);
      } else {
        ContentService.getContent({id: "atex.story.content.configurations"}).then(function (content) {
          contents = [];

          var configurations = atex.onecms.ObjectUtils.getByPath(content, 'data/aspects/contentData/data/configurations') || [];
          angular.forEach(configurations, function (configuration) {
            removeType(configuration.job);

            contents[configuration.id] = {
              job: configuration.job
            };

            angular.forEach(configuration.tasks, function (task) {
              removeType(task.configurations);

              contents[configuration.id][task.type] = task.configurations;
            });
          });

          deferred.resolve(contents);
        }).then(null, function (error) {
          deferred.reject(error);
        });
      }

      return deferred.promise;
    };

    return {
      job: function (content, configurationId) {
        return getStoryContentConfigurations().then(function (configurations) {
          if (configurationId && configurations[configurationId]) {
            var configuration = configurations[configurationId];
            angular.forEach(configuration.job, function (value, key) {
              if (value.startsWith("template:")) {
                DamService.getAspectFromTemplate(getTemplateKey(value)).then(function (aspect) {
                  setByPath(content, key, JSON.stringify(aspect));
                });
              } else {
                setByPath(content, key, value);
              }
            });

            setByPath(content, "data/aspects/contentData/data/_type", "\"atex.dam.standard.Job\"");
            setByPath(content, "data/aspects/contentData/data/objectType", "\"job\"");
            setByPath(content, "data/aspects/contentData/data/inputTemplate", "\"p.DamJob\"");
          }
        }).then(null, function (error) {
          var message = $translate.getTranslationTable().__GENERIC_ERROR_MSG__ + " (" + error.cause + ")";
          DamNotificationService.addNotification(atex.dam.Notification({type: 'error', message: message}), true);
        });
      },

      task: function (content, configurationId, task) {
        return getStoryContentConfigurations().then(function (configurations) {
          if (configurationId && configurations[configurationId]) {
            var configuration = configurations[configurationId];
            angular.forEach(configuration[task], function (value, key) {
              if (value.startsWith("template:")) {
                DamService.getAspectFromTemplate(getTemplateKey(value)).then(function (aspect) {
                  setByPath(content, key, JSON.stringify(aspect));
                });
              } else {
                setByPath(content, key, value);
              }
            });
          }
        }).then(null, function (error) {
          var message = $translate.getTranslationTable().__GENERIC_ERROR_MSG__ + " (" + error.cause + ")";
          DamNotificationService.addNotification(atex.dam.Notification({type: 'error', message: message}), true);
        });
      }
    };
  }]);